import {
  getAllOrders,
  getAvailabeKits,
  allAddresses,
  createOrder,
  createAddresses,
  getCountries,
  shareOrder,
  orderDetail,
  deleteAddress,
  allAddresses2,
  editAddresses,
  getSiteDocuments,
  getAvailabeCases,
  checkSiteForKitsAccess,
  checkSiteForReportsAccess
} from '../Services/order';
import { 
  setAllOrders, 
  setAllKitsforSite, 
  setAllAddresses, 
  setAllCountriesReducer, 
  setOrderDetail, 
  setDeleteAddress, 
  setAllAddresses2, 
  setHasKitsAccess,
  setHasReportsAccess 
} from '../Store/reducers/orders';
import { setSiteDocuments} from '../Store/reducers/site';
import { store } from '../Store';


const getSiteDocumentsAction = async (id) => {
  const result = await getSiteDocuments(id);
  store.dispatch(setSiteDocuments(result.data));
  return result;
};

const getAllOrdersAction = async (id) => {
  const result = await getAllOrders(id);
  store.dispatch(setAllOrders(result.data));
  return result;
};

const getAvailabeKitsAction = async (id, useDispatch = true) => {
  const result = await getAvailabeKits(id);
  const kits = result.data.map((data) => {
    const localItems = localStorage.getItem('cart-item-ids')?.split(',');
    if (localItems?.includes(String(data.id))) {
      const itemsAdded = localItems?.filter((itm) => itm === String(data.id))?.length;
      return { ...data, addtocart: true, count: data.count ? data.count : itemsAdded || 1 };
    } else {
      return data;
    }
  });
  if (useDispatch) store.dispatch(setAllKitsforSite(kits));
  return result;
};

const editAddressesAction = async (id, data) => {
  const result = await editAddresses(id, data);
  return result;
};
const getAllAddresses = async (id) => {
  const result = await allAddresses(id);
  store.dispatch(setAllAddresses(result.data));
  return result;
};

const getAllAddresses2 = async () => {
  const result = await allAddresses2();
  if (result.status === 200) {
    store.dispatch(setAllAddresses2(result.data));
  }
  return result;
};

const deleteAddressAction = async (id, reason) => {
  const result = await deleteAddress(id, reason);
  if (result.status === 200) {
    store.dispatch(setDeleteAddress(id));
  }
  return result;
};

const createNewOrder = async (data) => {
  const result = await createOrder(data);
  //store.dispatch(setAllAddresses(result.data));
  return result;
};

const createNewAddresses = async (data) => {
  const result = await createAddresses(data);
  //store.dispatch(setAllAddresses(result.data));
  return result;
};

const getAllCountries = async () => {
  const result = await getCountries();
  store.dispatch(setAllCountriesReducer(result?.data));
};

const shareNewOrder = async (id, data) => {
  const result = await shareOrder(id, data);
  return result;
};

const orderDetailAction = async (id, siteId) => {
  const result = await orderDetail(id, siteId);
  store.dispatch(setOrderDetail(result?.data));
};

const checkSiteForKitsAccessAction = async (id) => {
  const result = await checkSiteForKitsAccess(id);
  store.dispatch(setHasKitsAccess(result?.data));
};

const checkSiteForReportsAccessAction = async (id) => {
  const result = await checkSiteForReportsAccess(id);
  store.dispatch(setHasReportsAccess(result?.data));
};

export {
  editAddressesAction,
  getAllAddresses2,
  deleteAddressAction,
  getAllOrdersAction,
  getAvailabeKitsAction,
  getAllAddresses,
  createNewOrder,
  createNewAddresses,
  getAllCountries,
  shareNewOrder,
  orderDetailAction,
  getSiteDocumentsAction,
  checkSiteForKitsAccessAction,
  checkSiteForReportsAccessAction
};
